/**
 *
 * Asynchronously loads the component for AssessmentMagicLink
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/AssessmentMagicLink/loadable.js